<i18n>
{
  "en":{},
  "kr": {
    "Product": "제품소개",
    "Features": "기능소개",
    "Roadmap": "로드맵",
    "Download": "다운로드",
    "Support": "고객지원"
  }
}
</i18n>

<template>
  <div id="app">
    <ul class="navigation">
      <li>
        <img src="/static/imgs/synapbook_logo.png">
      </li>
      <li>
        <router-link v-bind:to="{ name: 'home-page' }">{{$t("Product")}}</router-link>
      </li>
      <li>
        <router-link v-bind:to="{ name: 'features-page' }">{{$t("Features")}}</router-link>
      </li>
      <li>
        <router-link v-bind:to="{ name: 'download-page' }">{{$t("Download")}}</router-link>
      </li>
      <li>
        <router-link v-bind:to="{ name: 'faq-page' }">{{$t("FAQ")}}</router-link>
      </li>
      <li>
        <router-link v-bind:to="{ name: 'support-page' }">{{$t("Support")}}</router-link>
      </li>
      <li>
        <LocaleSwicher :locales="['en', 'kr']" :dropup="false" :show-full="true"></LocaleSwicher>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
// import store from 'src/vuex/store'
import LanguageChooser from "./components/LanguageChooser";
import LocaleSwicher from "./components/LocaleSwicher";

export default {
  // store,
  name: "App",
  components: {
    LanguageChooser,
    LocaleSwicher
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.navigation {
  list-style-type: none;
  padding: 0;
}
.navigation li {
  display: inline-block;
  margin: 0 10px;
}
.navigation a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue